<template>
  <div style="background-color: #000000">
    <myheader v-if="isHarmonys" headTitle="扫一扫"></myheader>
    <!-- <div class="header">
			<div>
				<div class="back">
					<i class="iconfont iconfangxiangzuoN"></i>
				</div>
				<div class="title text16 all_text_center textcolorwhite font_weight_600">二维码扫描</div>
			</div>
		</div> -->
    <!-- <div style="float: top;height: 2rem;background-color: white;z-index:99999999;"></div> -->
    <div id="scancode" class="scancode all_text_center"></div>
  </div>
</template>

<script>
import {
  Dialog
} from 'vant';
import {
  realLiveAuth,
  initIosAuth
} from '../../utils/nativeRealLiveAuth.js';
import {
  getSealHashSign
} from '../../utils/nativeCertSign.js';
import {
  isHarmony,
  startScan
} from '../../utils/nativeOtherOperate.js';
import {
  setEssToken
} from "../../utils/cookies.js";
export default {
  data() {
    return {
      currentWebview: null,
      scanTool: null,
      //返回按钮
      leftView: null,
      //
      leftPath: require('@/assets/scancode/left_back.png'), //'./static/scancode/images/left_back.png'
      //
      leftBitmap: null,
      //标题
      titleView: null,
      //选图按钮
      rightView: null,
      //
      rightPath: require('@/assets/scancode/gallery_pick.png'), //'./static/scancode/images/gallery_pick.png',
      //
      rightBitmap: null,
      //闪光灯按钮
      flashOnView: null,
      //闪光灯按钮
      flashOffView: null,
      //
      flashOnPath: require('@/assets/scancode/flash_on.png'), //'./static/scancode/images/flash_on.png',
      flashOffPath: require('@/assets/scancode/flash_off.png'), //'./static/scancode/images/flash_off.png',
      //
      flashOnBitmap: null,
      //
      flashOffBitmap: null,
      //闪光灯状态
      flash: false,
      //实人，活体认证,扫码签requestId,
      requestId: '',
      //扫码签appCode,
      appCode: '',
      //扫码签token,
      token: '',
      //token
      verifyToken: '',
      //
      clickId: '',
      // //实人，活体认证是否上传结果
      // canNotify: false,
      //原生工具类
      tool: null,
      //
      retryIndex: 0,
      //
      retryCount: 0,
      //
      index: 0,
      //
      isHarmonys: isHarmony()
    }
  },
  methods: {
    //登录操作
    saveQrCodeLoginConfirmUser(data) {
      let that = this
      Dialog.confirm({
        title: '提示',
        message: '确定登录该设备？',
        confirmButtonText: '确定',
        confirmButtonColor: '#0277FC'
      })
        .then(() => {
          that.$store.dispatch(this.$LoadShow, true)
          that.$sealp('/face/api/qr/loginConfirm',
            JSON.stringify({
              staffId: this.$store.state.loginInfo.staffId,
              requestId: data
            }))
            .then((res) => {
              that.$store.dispatch(that.$LoadShow, false)
              if (res.success) {
                that.$Toast('登录成功！');
                that.$router.go(-1)
              } else {
                that.$Toast(res.message || '登录失败！');
                that.resetScan()
              }
            }).catch((err) => {
              console.log('loginConfirm--=', err)
              this.$store.dispatch(this.$LoadShow, false)
              this.$Toast(err.responseJSON.message || '登录失败！')
            });
        })
        .catch(() => {
          that.resetScan()
        });
    },
    //根据扫码返回数据获取任务类型和数据
    getResultType(requestId) {
      let type = requestId.substr(0, 3)
      switch (type) {
        //实人认证
        case 'af-':
        //活体认证
        case 'lf-':
        //模拟认证
        case 'MOC':
          //调用实人认证或活体认证
          this.$store.dispatch(this.$LoadShow, true)
          realLiveAuth({
            type: '3',
            requestId: requestId
          })
          //this.getCerifyIdForRequestId(requestId)
          break;
        //扫码登录
        case 'sl-':
          this.saveQrCodeLoginConfirmUser(requestId)
          break;
        //扫码签
        case 'ss-':
          this.parseData(requestId)
          break;
        //扫码跳转合同存证报告
        case 'ct-':
          this.parseContractData(requestId)
          break;
        default:
          this.$Toast('二维码无效，请重试！');
          this.resetScan()
          break;
      }
    },
    //
    parseContractData(codeData) {
      let that = this
      let tmp = codeData.split('||')
      if (tmp[1]) {
        Dialog.confirm({
          title: '提示',
          message: '识别到合同二维码内容：' + tmp[1] + '，需要跳转到存证报告页面吗？',
          confirmButtonText: '确定',
          confirmButtonColor: '#0277FC'
        })
          .then(() => {
            that.$router.push({
              path: '/contractevidenceinfo',
              query: {
                contractCode: tmp[0].substring(3),
              }
            })
          })
          .catch(() => {
            that.resetScan()
          });
      }
    },
    //获取esstoken
    getEssToken() {
      document.cookie = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/seal/api/genAppToken', {
        appCode: this.appCode
      }).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.token = res.data
          //this.appCode = res.data.appCode
          //this.requestId = requestId
          this.clickId = this.Tool.generateUUID()
          this.getQrNextArgsForRequestId()
        } else {
          this.$Toast(res.message || '获取token失败，请重试!')
        }
      }).catch((err) => {
        console.log('catch--=', err)
        this.$store.dispatch(this.$LoadShow, false)
        this.$Toast('获取token失败，请重试!')
      });
    },
    //解析扫码签data获取requestId和verifyToken
    parseData(codeData) {
      let temp = codeData.split('||')
      if (temp && Array.isArray(temp) && temp.length > 1) {
        this.requestId = temp[0]
        this.appCode = temp[1]
        //this.verifyToken = temp[2]
        this.getEssToken()
        //this.getQrNextArgsForRequestId()
      } else {
        this.$message.error('获取数据失败，请重试！')
      }
    },
    //扫码签根据requestId获取盖章数据
    getQrNextArgsForRequestId(data) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealp('/api/doc/sign/qr/nextArgs?token=' + this.token,
        JSON.stringify({
          requestId: this.requestId,
          lockId: data ? data.lockId : '',
          fileId: data ? data.fileId : ''
        }), this.appCode)
        .then(res => {
          if (res.success) {
            if (res.data) {
              if (data) {
                res.data.lockId = data.lockId
                res.data.fileId = data.fileId
              }
              //测试代码
              // if (this.index === 3) {
              //   res.data.isFinished = null
              // }
              if (!this.verifyToken) {
                this.verifyToken = res.data.token
              }
              if (this.checkIsFinished(res.data.isFinished)) {
                this.getSignFileHash(res.data)
              } else {
                this.showMessageInfoAlert('盖章记录异常，请重新盖章！', 0, '关闭')
              }
            } else {
              this.signResultToast('完成盖章!', false)
              //this.completeSign()
            }
          } else {
            this.signResultToast(res.message)
          }
        }).catch(err => {
          console.log('catch--=', err)
          this.signResultToast(res.message)
        })
    },
    checkIsFinished(field) {
      if (field === false || field === true || field === 0 || field === 1) {
        return true; // 通过
      }
      return false; // 不通过，包括 "", null, undefined 等
    },
    //扫码签盖章流程错误流程
    signResultToast(message, flag = true) {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast(message || '盖章失败，请重试!')
      if (flag) {
        //盖章失败请求接口
        this.$sealps('/api/doc/sign/qr/signerr?requestId=' + this.requestId + '&token=' + this.token, {},
          this.appCode).then(res => {
            if (!res.success) {
              this.$Toast(res.message || '盖章状态更新失败!')
            }
          }).catch(err => {
            this.$Toast(err.message || '盖章状态更新失败!')
            console.log('signerr', err)
          })
      }
      setTimeout(() => {
        this.resetScan()
      }, 1000)
    },
    //扫码签获取印章文件hash值
    getSignFileHash(obj) {
      this.$sealps('/api/doc/sign/pkcs?token=' + this.token, JSON.stringify({
        docId: obj.docId,
        segId: obj.segId,
        lockId: obj.lockId,
        fileId: obj.fileId,
        certId: obj.certId,
        signetImgId: obj.signetImgId,
        corpId: obj.corpId,
        staffId: obj.staffId,
        allowSealDate: obj.allowSealDate,
        page: {
          x: obj.page.x,
          y: obj.page.y,
          index: obj.page.index,
          //zoom: obj.page.zoom,
          timeFlag: obj.page.timeFlag,
          reason: obj.page.reason
        },
        //isMobile: true,
      }), {
        appCode: this.appCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success && res.data) {
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          this.signFlowSealHashSign(obj, res.data, this.$store.state.loginInfo.userName)
        } else {
          this.signResultToast(res.message || res.messageDetail || '盖章获取数据失败，请联系管理员!')
        }
      }).catch((error) => {
        console.log('catch--=', error)
        this.signResultToast('盖章获取数据失败，请重试！')
      })
    },
    //调用证书签署
    signFlowSealHashSign(obj, hashData, userName) {
      getSealHashSign(hashData.signingAttr.certSn,
        hashData.signingPkcs, userName).then(res => {
          if (res) {
            this.signFlowItemFinish(obj, res, hashData)
          } else {
            this.signResultToast('证书签名失败，请检查用户证书！')
          }
        }).catch(err => {
          this.signResultToast('证书签名失败，请检查用户证书！')
        })
    },
    //扫码签提交签署一个印章数据
    signFlowItemFinish(obj, signdata, data) {
      this.$sealps('/api/doc/sign/save?token=' + this.token, JSON.stringify({
        docId: obj.docId,
        segId: obj.segId,
        lockId: data.lockId,
        fileId: data.fileId,
        corpId: obj.corpId,
        staffId: obj.staffId,
        signedData: signdata,
        signingAttr: data.signingAttr,
        qrRequestId: data.qrRequestId,
        isFinished: obj.isFinished,
        clkId: this.clickId,
      }), {
        appCode: this.appCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success && res.data) {
          this.retryIndex = 0
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          this.index++
          this.getQrNextArgsForRequestId(res.data)
        } else {
          //this.signResultToast(res.message || res.messageDetail || '盖章失败，请联系管理员！')
          if (res.code == 'VE001') {
            if (this.retryIndex >= 5) {
              this.retryIndex = 0
              this.$store.dispatch(this.$LoadShow, false)
              this.showMessageInfoAlert('盖章失败，请继续拖动印章到文件还未盖章处，点击【签署文件】完成盖章!', 0, '关闭')
            } else {
              this.retryIndex++
              this.retryCount++
              obj.lockId = data.lockId
              this.getSignFileHash(obj)
            }
          } else {
            this.signResultToast(res.message || res.messageDetail || '盖章失败，请联系管理员！')
          }
        }
      }).catch((error) => {
        console.log('catch--=', error)
        this.signResultToast('盖章失败，请重试！')
      })
    },
    //扫码签实人、活体认证成功
    scanAuthSucced() {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast('认证成功！')
      this.$router.go(-1)
    },
    //扫码签实人、活体认证失败
    scanAuthFailed(msg) {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast(msg || '认证失败，请重新认证！')
      setTimeout(() => {
        this.resetScan()
      }, 3000)
    },
    //鸿蒙扫码后调用逻辑
    onScanResult(result) {
      console.log('onScanResult-=', result, typeof result)
      result = result.replace(/\n/g, '')
      if (result.search('af-') != -1 || result.search('lf-') != -1 ||
        result.search('sl-') != -1 || result.search('ss-') != -1 || result.search('ct-') != -1 || result.search('MOCK-') != -1) {
        //请求接口
        //从result中获取要执行操作的类型和其他信息（requestid或登录，或盖章hash）
        this.getResultType(result)
      } else if (result.search('back_admin') != -1) {
        this.$router.back()
      } else if (result.search('back') != -1) {
        this.$Toast('不能调用扫码服务，请联系管理员！');
        this.$router.back()
      } else {
        this.$Toast('二维码无效，请重试！');
        setTimeout(() => {
          this.resetScan()
        }, 2000)
      }
    },
    //扫码结果返回接受
    onmarked(type, result, file) {
      console.log('scan-result-=', result, type, file)
      result = result.replace(/\n/g, '');
      this.$store.dispatch(this.$LoadShow, false)
      this.scanTool.close();
      //这里写扫码结束后 自己的逻辑
      // if (result.search('corpId') != -1) {
      // 	let data = JSON.parse(result)
      // 	//console.log(data)
      // 	//跳转加入企业页面
      // 	this.$router.push({
      // 		path: '/joinenterprise',
      // 		query: {
      // 			corpId: data.corpId,
      // 		}
      // 	})
      // } else 
      if (result.search('af-') != -1 || result.search('lf-') != -1 ||
        result.search('sl-') != -1 || result.search('ss-') != -1 || result.search('ct-') != -1 || result.search('MOCK-') != -1) {
        //请求接口
        //从result中获取要执行操作的类型和其他信息（requestid或登录，或盖章hash）
        this.getResultType(result)
      } else {
        this.$Toast('二维码无效，请重试！');
        setTimeout(() => {
          this.resetScan()
        }, 2000)
      }
    },
    //
    showMessageInfoAlert(message, type, confirmButtonText = '关闭') {
      Dialog.alert({
        title: '提示',
        message: message,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#0277FC'
      }).then(() => {
        if (type === 0) {
          this.signResultToast('盖章失败，请重试！')
        }
      });
    },
    //初始化摄像头和预览 
    initSacn() {
      let that = this;
      if (isHarmony()) {
        startScan()
        return
      }
      console.log('window-=', window, window.plus)
      if (!window.plus) {
        this.$Toast('扫码初始化失败！');
        this.$router.go(-1)
        return;
      }
      this.scanTool = new plus.barcode.Barcode('scancode', [plus.barcode.QR], {
        frameColor: '#00FF00',
        scanbarColor: '#00FF00'
      });
      this.scanTool.onmarked = this.onmarked;
      this.scanTool.start()
      this.createChildView()
      //ios版每次使用前需要初始化
      initIosAuth()
    },
    //扫码重置
    resetScan() {
      let that = this;
      if (isHarmony()) {
        startScan()
        return
      }
      this.scanTool = null
      if (!window.plus) return;
      this.scanTool = new plus.barcode.Barcode('scancode', [plus.barcode.QR], {
        frameColor: '#00FF00',
        scanbarColor: '#00FF00'
      });
      this.scanTool.onmarked = this.onmarked;
      this.scanTool.start()
    },
    //创建子控件
    createChildView() {
      let _that = this
      // if (window.plus && plus.os.name === 'iOS') {
      // 	this.leftPath = window.location.origin + '/m/static/scancode/images/left_back.png'
      // 	this.rightPath = window.location.origin + '/m/static/scancode/images/gallery_pick.png'
      // 	this.flashOnPath = window.location.origin + '/m/static/scancode/images/flash_on.png'
      // 	this.flashOffPath = window.location.origin + '/m/static/scancode/images/flash_off.png'
      // }
      //头部背景和标题
      this.titleView = new plus.nativeObj.View('header', {
        top: '0px',
        left: '0px',
        height: '84px',
        width: '100%',
        backgroundColor: 'rgba(2,119,252,0.5)'
      },
        [{
          tag: 'font',
          id: 'headertext',
          text: '扫一扫',
          textStyles: {
            size: '20px',
            color: 'rgba(255,255,255,1)'
          },
          position: {
            top: '44px',
            left: '40%',
            width: '20%',
            height: '40px'
          }
        },])
      this.titleView.show()
      //返回按钮
      this.leftView = new plus.nativeObj.View('left', {
        top: '44px',
        left: '10px',
        height: '40px',
        width: '40px',
      });
      this.leftBitmap = new plus.nativeObj.Bitmap('leftimg')
      this.leftBitmap.loadBase64Data(this.leftPath, () => {
        _that.leftView.drawBitmap(_that.leftBitmap, {
          position: {
            top: '5px',
            left: '5px',
            width: '30px',
            height: '30px'
          },
        })
        //_that.leftBitmap.clear()
        _that.leftView.show();
      }, (error) => {
        console.log('leftBitmap', error)
      });
      this.leftView.addEventListener('click', function (e) {
        _that.$router.go(-1)
      }, false);
      //选择本地图片
      /*this.rightView = new plus.nativeObj.View('right', {
        top: '44px',
        left: '88%',
        width: '40px',
        height: '40px',
      });
      this.rightBitmap = new plus.nativeObj.Bitmap('rightimg')
      this.rightBitmap.loadBase64Data(this.rightPath, () => {
        _that.rightView.drawBitmap(_that.rightBitmap, {
          position: {
            top: '5px',
            left: '5px',
            width: '30px',
            height: '30px'
          },
        })
        _that.rightView.show();
      }, (error) => {
        console.log('rightBitmap', error)
      });
      this.rightView.addEventListener('click', function(e) {
        _that.selectImg()
      }, false);
      */
      // this.rightView.draw([{
      // 	tag: 'img',
      // 	id: 'rightimg',
      // 	src: './static/scancode/images/gallery_pick.png',
      // 	position: {
      // 		top: '5px',
      // 		left: '5px',
      // 		width: '30px',
      // 		height: '30px'
      // 	}
      // }]);
      // this.rightView.show();
      //闪光灯
      // this.toolView = new plus.nativeObj.View('tool', {
      // 		top: '75%',
      // 		left: '45%',
      // 		width: '10%',
      // 		height: '50px',
      // 	},
      // 	[{
      // 		tag: 'img',
      // 		id: 'flash',
      // 		src: _that.flashOnPath,
      // 		position: {
      // 			top: '0px',
      // 			left: '0px',
      // 			width: '50px',
      // 			height: '50px'
      // 		},
      // 	}]);
      this.flashOnView = new plus.nativeObj.View('flashOn', {
        top: '75%',
        left: '45%',
        width: '10%',
        height: '50px',
      });
      this.flashOnBitmap = new plus.nativeObj.Bitmap('flashonimg')
      this.flashOnBitmap.loadBase64Data(this.flashOnPath, () => {
        _that.flashOnView.drawBitmap(_that.flashOnBitmap, {
          position: {
            top: '0px',
            left: '0px',
            width: '50px',
            height: '50px'
          },
        })
      }, (error) => {
        console.log('flashOnBitmap', error)
      });
      this.flashOffView = new plus.nativeObj.View('flashOff', {
        top: '75%',
        left: '45%',
        width: '10%',
        height: '50px',
      });
      this.flashOffBitmap = new plus.nativeObj.Bitmap('flashoffimg')
      this.flashOffBitmap.loadBase64Data(this.flashOffPath, () => {
        _that.flashOffView.drawBitmap(_that.flashOffBitmap, {
          position: {
            top: '0px',
            left: '0px',
            width: '50px',
            height: '50px'
          },
        })
      }, (error) => {
        console.log('flashOnBitmap', error)
      });
      this.flashOnView.show();
      this.flashOnView.addEventListener('click', function (e) {
        _that.switchFlash()
      }, false)
      this.flashOffView.addEventListener('click', function (e) {
        _that.switchFlash()
      }, false)
    },
    //切换闪光灯
    switchFlash() {
      let that = this
      this.flash = !this.flash
      this.scanTool.setFlash(this.flash)
      if (this.flash) {
        this.flashOnView.hide();
        this.flashOffView.show();
        // this.toolView.draw([{
        // 	tag: 'img',
        // 	id: 'flash',
        // 	src: that.flashOnPath,
        // 	position: {
        // 		top: '0px',
        // 		left: '0px',
        // 		width: '50px',
        // 		height: '50px'
        // 	},
        // }])
      } else {
        this.flashOnView.show();
        this.flashOffView.hide();
        // this.toolView.draw([{
        // 	tag: 'img',
        // 	id: 'flash',
        // 	src: that.flashOffPath,
        // 	position: {
        // 		top: '0px',
        // 		left: '0px',
        // 		width: '50px',
        // 		height: '50px'
        // 	},
        // }])
      }
    },
    //选择图片
    selectImg() {
      let that = this
      plus.gallery.pick(function (path) {
        //console.log(path)
        that.$store.dispatch(that.$LoadShow, true)
        plus.barcode.scan(path, that.onmarked, function (error) {
          //console.log(error)
          that.$store.dispatch(that.$LoadShow, false)
          that.$Toast('无法识别此图片');
          //plus.nativeUI.alert('无法识别此图片');
        });
      }, function (err) {
        that.$store.dispatch(that.$LoadShow, false)
        that.$Toast('没有选择图片');
        //console.log('Failed: ' + err.message);
      });
    },
    imgToBase64(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth; // 保留原始尺寸‌:ml-citation{ref="2" data="citationList"}
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const base64 = canvas.toDataURL('image/png');
          console.log('imgToBase64', url, base64);
          resolve(base64);
        };
        img.onerror = reject;
      });
    }
  },
  mounted() {
    this.initSacn()
    //5377212EB241758DB7A310A507CEDBB4
    //6EB76841EF1BA9540759D04C2AD1F227
    // setTimeout(() => {
    // 	let test = getSealHashSign('7C2CE092BC31163ADA0DFEA31CAF99D7', '1234567890', this.$store.state
    // 		.loginInfo.userName)
    // 	console.log('text', test)
    // }, 1000)
  },
  created() {
    window.scanAuthSucced = this.scanAuthSucced
    window.scanAuthFailed = this.scanAuthFailed
    window.onScanResult = this.onScanResult
  },
  beforeDestroy() {
    if (window.plus) {
      //view关闭和开启自动回收
      this.scanTool.close()
      this.titleView.close()
      this.leftView.close()
      //this.rightView.close()
      this.flashOnView.close()
      this.flashOffView.close()
      this.leftBitmap.clear()
      //this.rightBitmap.clear()
      this.flashOffBitmap.clear()
      this.flashOnBitmap.clear()
      if (plus.os.name === 'Android') {
        plus.android.autoCollection(this.scanTool);
        plus.android.autoCollection(this.titleView);
        //plus.android.autoCollection(this.rightView);
        plus.android.autoCollection(this.leftView);
        plus.android.autoCollection(this.flashOnView);
        plus.android.autoCollection(this.flashOffView);
      } else if (plus.os.name === 'iOS') {
        plus.ios.deleteObject(this.scanTool);
        plus.ios.deleteObject(this.titleView);
        //plus.ios.deleteObject(this.rightView);
        plus.ios.deleteObject(this.leftView);
        plus.ios.deleteObject(this.flashOnView);
        plus.ios.deleteObject(this.flashOffView);
      }
    }
  },
  destroyed() { }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global.css";

.scancode {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>